import { render } from "./HomepageTrainings.vue?vue&type=template&id=b8f4e946"
import script from "./HomepageTrainings.vue?vue&type=script&lang=js"
export * from "./HomepageTrainings.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__